import { useLoaderData } from 'react-router';

import { useQuotation } from '~/api/quotations';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import type { loader } from './CreateQuotation.loader';

import { CreateEditQuotationForm } from './CreateEditQuotationForm';

export const CreateQuotation = () => {
  const loaderData = useLoaderData<typeof loader>();
  const { data: quotation } = useQuotation(loaderData.id);

  if (!quotation || quotation.status !== 'Draft') return <Redirect to={routes.quotations} />;

  return <CreateEditQuotationForm mode="create" quotation={quotation} />;
};
